import React from "react";
import ReactMarkdown from "react-markdown";

async function fetchMarkdown(url: string) {
  const response = await fetch(url);
  const text = await response.text();
  return text;
}

export default function Help() {
  const [content, setContent] = React.useState("");

  React.useEffect(() => {
    const markdownUrl =
      "https://fly.storage.tigris.dev/pedidoz-public-images/landing-page/help/help.md";
    fetchMarkdown(markdownUrl).then(setContent);
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Ajuda</h1>
      <div className="prose prose-sm sm:prose lg:prose-lg xl:prose-xl mx-auto">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
}
